import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("monitoring_billing.title"))),
      ]),
      _vm._t("default"),
      _c("actions-component", {
        attrs: { class_table: _vm.getClassTable },
        scopedSlots: _vm._u([
          {
            key: "description",
            fn: function () {
              return [
                _vm._v(
                  " " + _vm._s(_vm.$t("monitoring_billing.subtitle")) + " "
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    staticClass: "ml-1 btn-inca-secondary",
                    attrs: { dense: "", outlined: "" },
                    on: { click: _vm.addItem },
                  },
                  [
                    _c(VIcon, { attrs: { small: "" } }, [
                      _vm._v("mdi-plus"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("attributes.managment.button.create")) +
                        " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(VRow, [
        _c(
          "div",
          { class: _vm.getClassTable },
          [
            _c(
              VCard,
              [
                _c(
                  VContainer,
                  { staticClass: "justify-center", attrs: { fluid: "" } },
                  [
                    _c(VDataTable, {
                      key: _vm.key_items,
                      staticClass: "text-center table-inca",
                      attrs: {
                        headers: _vm.headers,
                        items: _vm.items,
                        "sticky-header": "",
                        "hide-default-footer": "",
                        loading: _vm.isLoading,
                        hover: "",
                        responsive: "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "item.maintenance",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c("span", [
                                _vm._v(_vm._s(item.maintenance ? "Sí" : "No")),
                              ]),
                            ]
                          },
                        },
                        {
                          key: "item.actions",
                          fn: function (ref) {
                            var item = ref.item
                            return [
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VIcon,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: { medium: "" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.editItem(
                                                          item
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [_vm._v(" mdi-pencil ")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v("Editar")])]
                              ),
                              _c(
                                VTooltip,
                                {
                                  attrs: { bottom: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function (ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              VIcon,
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: { medium: "" },
                                                    on: {
                                                      click: function () {
                                                        return _vm.deleteItem(
                                                          item,
                                                          _vm.DIALOG_DELETE
                                                        )
                                                      },
                                                    },
                                                  },
                                                  "v-icon",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " mdi-trash-can-outline "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [_c("span", [_vm._v("Eliminar")])]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("dialogs-component", {
        ref: _vm.DIALOG_REPORT,
        attrs: {
          title: _vm.$t("monitoring_billing.title"),
          "show-buttons": true,
          width: 900,
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  VForm,
                  {
                    ref: "form",
                    staticClass: "form mt-2",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.valid,
                      callback: function ($$v) {
                        _vm.valid = $$v
                      },
                      expression: "valid",
                    },
                  },
                  [
                    _c(
                      VRow,
                      { attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Título")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9", lg: "10" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                filled: _vm.readonly,
                                outlined: !_vm.readonly,
                                readonly: _vm.readonly,
                                "hide-details": "auto",
                                dense: "",
                                rules: _vm.rules.general,
                              },
                              model: {
                                value: _vm.report.title,
                                callback: function ($$v) {
                                  _vm.$set(_vm.report, "title", $$v)
                                },
                                expression: "report.title",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-2", attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Link")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9", lg: "10" } },
                          [
                            _c(VTextField, {
                              attrs: {
                                filled: _vm.readonly,
                                outlined: !_vm.readonly,
                                readonly: _vm.readonly,
                                "hide-details": "auto",
                                dense: "",
                                rules: _vm.rules.general,
                                type: "url",
                              },
                              model: {
                                value: _vm.report.link,
                                callback: function ($$v) {
                                  _vm.$set(_vm.report, "link", $$v)
                                },
                                expression: "report.link",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-2", attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Key(s)")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9", lg: "10" } },
                          [
                            _c(VCombobox, {
                              attrs: {
                                filled: _vm.readonly,
                                outlined: !_vm.readonly,
                                readonly: _vm.readonly,
                                "hide-details": "auto",
                                dense: "",
                                rules: _vm.rules.general,
                                multiple: "",
                                items: _vm.keys,
                                label: "Escriba una o varias llaves",
                                chips: "",
                                clearable: "",
                              },
                              model: {
                                value: _vm.report.keys,
                                callback: function ($$v) {
                                  _vm.$set(_vm.report, "keys", $$v)
                                },
                                expression: "report.keys",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-2", attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Rol")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9", lg: "10" } },
                          [
                            _c(VAutocomplete, {
                              attrs: {
                                name: "role",
                                items: _vm.selectRols,
                                required: "",
                                multiple: "",
                                label: "Seleccione",
                                outlined: "",
                                dense: "",
                                "small-chips": true,
                                "return-object": true,
                                "deletable-chips": true,
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "selection",
                                  fn: function (ref) {
                                    var item = ref.item
                                    var index = ref.index
                                    return [
                                      _c(
                                        VChip,
                                        _vm._b(
                                          {
                                            attrs: {
                                              "input-value": item,
                                              close: "",
                                            },
                                            on: {
                                              "click:close": function ($event) {
                                                return _vm.report.roles.splice(
                                                  index,
                                                  1
                                                )
                                              },
                                            },
                                          },
                                          "v-chip",
                                          item,
                                          false
                                        ),
                                        [_vm._v(" " + _vm._s(item) + " ")]
                                      ),
                                    ]
                                  },
                                },
                              ]),
                              model: {
                                value: _vm.report.roles,
                                callback: function ($$v) {
                                  _vm.$set(_vm.report, "roles", $$v)
                                },
                                expression: "report.roles",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      VRow,
                      { staticClass: "mt-2", attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("En mantenimiento")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(VSwitch, {
                              model: {
                                value: _vm.report.maintenance,
                                callback: function ($$v) {
                                  _vm.$set(_vm.report, "maintenance", $$v)
                                },
                                expression: "report.maintenance",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.companyCode === _vm.DATA_OFFICE_COMPANY_CODE
                          ? _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Dashboard Multiempresa")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.companyCode === _vm.DATA_OFFICE_COMPANY_CODE
                          ? _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(VSwitch, {
                                  model: {
                                    value: _vm.report.multiorg,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "multiorg", $$v)
                                    },
                                    expression: "report.multiorg",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm.report.multiorg &&
                    _vm.companyCode === _vm.DATA_OFFICE_COMPANY_CODE
                      ? _c(
                          VRow,
                          { staticClass: "mt-2", attrs: { dense: "" } },
                          [
                            _c(
                              VCol,
                              { attrs: { cols: "3", lg: "2" } },
                              [
                                _c(
                                  VSubheader,
                                  { staticClass: "font-weight-bold" },
                                  [_vm._v("Organización")]
                                ),
                              ],
                              1
                            ),
                            _c(
                              VCol,
                              { attrs: { cols: "9", lg: "10" } },
                              [
                                _c(VCombobox, {
                                  attrs: {
                                    multiple: "",
                                    chips: "",
                                    outlined: "",
                                    dense: "",
                                    items: _vm.organizations,
                                    "item-value": "id",
                                    "item-text": "name",
                                    rules: _vm.rules.general,
                                    attach: true,
                                  },
                                  model: {
                                    value: _vm.report.organizations,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.report, "organizations", $$v)
                                    },
                                    expression: "report.organizations",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      VRow,
                      { staticClass: "mt-2", attrs: { dense: "" } },
                      [
                        _c(
                          VCol,
                          { attrs: { cols: "3", lg: "2" } },
                          [
                            _c(
                              VSubheader,
                              { staticClass: "font-weight-bold" },
                              [_vm._v("Descripción")]
                            ),
                          ],
                          1
                        ),
                        _c(
                          VCol,
                          { attrs: { cols: "9", lg: "10" } },
                          [
                            _c(VTextarea, {
                              attrs: {
                                "hide-details": "auto",
                                outlined: !_vm.readonly,
                                dense: "",
                                filled: _vm.readonly,
                                readonly: _vm.readonly,
                                rules: _vm.rules.general,
                                required: "",
                                rows: "4",
                              },
                              model: {
                                value: _vm.report.description,
                                callback: function ($$v) {
                                  _vm.$set(_vm.report, "description", $$v)
                                },
                                expression: "report.description",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "btnsRight",
            fn: function () {
              return [
                _c(
                  VBtn,
                  {
                    attrs: { color: "primary" },
                    on: { click: _vm.updateInfo },
                  },
                  [
                    _c(VIcon, { attrs: { left: "" } }, [
                      _vm._v("icon-send"),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.flag_create
                            ? _vm.$t("frases.register")
                            : _vm.$t("frases.update")
                        ) +
                        " "
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("dialog-confirmation-component", {
        ref: _vm.DIALOG_DELETE,
        attrs: {
          title: "Confirmación",
          text: "¿Está seguro de eliminar este reporte?",
        },
        on: { onConfirm: _vm.onAceptarDelete },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }